import axios from "axios";
import { publicApiUrl } from "../util/Constants";
import type { HomepageStats, HallOfFameRecord } from "../types/domain";

export const statsApi = {
  homepage: async (): Promise<HomepageStats> => {
    const { data } = await axios.get<HomepageStats>(`${publicApiUrl}/stats/homepage`);
    return data;
  },

  hallOfFame: async (ladderId: number): Promise<HallOfFameRecord[]> => {
    const { data } = await axios.get<HallOfFameRecord[]>(`${publicApiUrl}/stats/hall-of-fame?ladderId=${ladderId}`);
    return data;
  },
};
